import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import IrqChoiceButtons from "../molecules/IrqChoiceButtons";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import ILearn from "../molecules/ILearn";

class PURCHASEIRQAsIsView extends Component {
  render() {
    const values = ["Yes", "No", "Not Sure"];
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle content={this.props.content} />
          <IrqChoiceButtons
            content={this.props.content}
            value={this.props.data.isBuyingAsIs}
            values={values}
            onChoiceMade={(index) => {
              this.props.customFormEdit("isBuyingAsIs", values[index]);
              this.props.navigationContext.goNext(
                this.props.navigationsAway.Primary,
                true
              );
            }}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(PURCHASEIRQAsIsView));
